<template>
    <el-drawer
        title="实名信息修改审核详情"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <template v-if="data && data.oldCp">
                <div class="page-group-title"><span>之前的实名信息</span></div>
                <table v-if="data" class="info-table" width="100%">
                    <tr>
                        <th width="80">真实姓名:</th>
                        <td>
                            {{data.oldCp.name}}
                        </td>
                        <th width="80">证件类型:</th>
                        <td>
                            <!-- {{documentType.get(data.oldCp.documentType)}} -->
                            {{data.oldCpDocumentTypeStr}}
                        </td>
                    </tr>
                    <tr>
                        <th width="80">证件号码:</th>
                        <td colspan="3">
                            {{data.oldCp.documentNumber}}
                        </td>
                    </tr>
                    <tr v-if="data.oldCp.documentPhoto">
                        <th width="80">证件照片:</th>
                        <td colspan="3">
                            <el-image
                                v-for="(item,index) in data.oldCp.documentPhoto"
                                :key="index"
                                :src="item | coverImage(120)"
                                fit="cover"
                                class="avatar"
                                :preview-src-list="data.oldCp.documentPhoto"
                            ></el-image>
                        </td>
                    </tr>
                </table>
            </template>
            <template v-if="data && data.updateCp">
                <div class="page-group-title MT20"><span>申请修改的实名信息</span></div>
                <table v-if="data" class="info-table" width="100%">
                    <tr>
                        <th width="80">真实姓名:</th>
                        <td>
                            {{data.updateCp.name}}
                        </td>
                        <th width="80">证件类型:</th>
                        <td>
                            <!-- {{documentType.get(data.updateCp.documentType)}} -->
                            {{data.updateCpDocumentTypeStr}}
                        </td>
                    </tr>
                    <tr>
                        <th width="80">证件号码:</th>
                        <td colspan="3">
                            {{data.updateCp.documentNumber}}
                        </td>
                    </tr>
                    <tr>
                        <th width="80">证件照片:</th>
                        <td colspan="3">
                            <el-image
                                v-for="(item,index) in data.updateCpDocumentPhotoList"
                                :key="index"
                                :src="item | coverImage(120)"
                                fit="cover"
                                class="avatar"
                                :preview-src-list="data.updateCpDocumentPhotoList"
                            ></el-image>
                        </td>
                    </tr>
                </table>
            </template>
            <div class="page-group-title MT20"><span>审核备注</span></div>
            <el-form
                :model="formData"
                ref="formData"
                label-position="top"
            >
                <el-form-item prop="remark" :rules="[{required: true, message: '请输入审核备注'}]" :show-message="formData.status == 3 ? true : false">
                    <el-input v-model="formData.remark" type="textarea" :rows="4" maxlength="100" show-word-limit placeholder="拒绝请写明理由，审核通过与拒绝都将通知用户"></el-input>
                </el-form-item>
            </el-form>
           
        </div>
        <div v-if="data" class="drawer-footer">
            <template v-if="data.operationRecord.status == 1 && $utils.have('/realname/audit/operation')">
                <el-button
                    type="success"
                    @click="auditEvent(2)"
                    :loading="btnLoading"
                    >通过</el-button
                >
                <el-button
                    type="warning"
                    @click="auditEvent(3)"
                    :loading="btnLoading"
                    >拒绝</el-button
                >
            </template>
            <el-tag v-if="data.operationRecord.status == 2" type="success">已通过</el-tag>
            <el-tag v-if="data.operationRecord.status == 3" type="info">已拒绝</el-tag>
            <el-tag v-if="data.operationRecord.status == 4" type="info">已撤销</el-tag>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading: false,
            id: "",
            data: null,
            formData:{
                id:'',
                remark:'',
                status:2
            }
        };
    },
    methods: {
        close() {
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
            this.drawerShow = false;
        },
        async show(id) {
            this.id = id;
            await this.getDataDetail();
            this.drawerShow = true;
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/realname/audit/detail",
                params: { operationRecordId: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.formData = {
                            ...this.formData,
                            id: this.id,
                            remark: result.operationRecord && result.operationRecord.remark || ''
                        }
                        if(this.data.oldCp && this.data.oldCp.documentPhoto){
                            this.data.oldCp.documentPhoto = this.data.oldCp.documentPhoto.split(',')
                        }
                    } else {
                        self.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //审核
        auditEvent(status) {
            this.formData.status = status;
            this.$refs["formData"].validate((valid) => {
                if (valid || status === 2) {
                    const _msg = status === 2 ? '确定要通过审核吗?' : '确定拒绝通过审核吗?';
                    this.$confirm(_msg, '提示', {
                            type: 'warning',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.btnLoading = true;
                            this.$request({
                                url: '/realname/audit/operation',
                                data: {
                                    ...this.formData
                                },
                                method: "post",
                            })
                                .then((res) => {
                                    const { state, msg } = res.data;
                                    if (state == 1) {
                                        this.$emit('onSuccess');
                                        this.close();
                                    } else {
                                        this.$message.error(msg || "操作失败,请重试");
                                    }
                                })
                                .catch(() => {
                                    this.$message.error("操作失败,请重试");
                                })
                                .finally(() => {
                                    this.btnLoading = false;
                                });
                        }).catch(() => {})
                }
            })
            
            
        }
    },
};
</script>

<style lang="scss" scoped>
.avatar{
    margin-right: 5px;
}
.page-group-title.MT20{
    margin-top: 20px;
}
</style>